import React, {useContext, useState} from "react";
import {makeStyles} from "@material-ui/styles";
import Colors from "../styles/colors";
import AppIcon from '../images/ascend-white.svg';
import {IStepTranscript} from "../interfaces/IStepTranscript";
import {AppContext} from "../App";
import {Redirect, useHistory} from "react-router-dom";
import {AppService} from "../services/app.service";
import {BASE_URL} from "../env.json";
import {ButtonTheme} from "../enums/ButtonTheme";
import ActionButton from "../components/ActionButton";


function Intro(props: IStepTranscript) {

    const introStyle = makeStyles({
        root: {
            width: window.innerWidth,
            height: window.innerHeight,
            position: "relative",
            background: Colors.primary,
            fontFamily: [
                'LotaGrotesque',
            ].join(','),
            paddingLeft: 24,
            paddingRight: 24,
            paddingBottom:24,
            paddingTop: 24,
            color: Colors.white,
            fontStretch: "normal",
            fontStyle: "normal",
        },
        icon: {
            width: 192,
            height: "auto",
        },
        greeting: {
            marginTop: 48,
            width: 136 * 2,
            height: 15,
            lineHeight: "normal",
            letterSpacing: "1px",
            fontWeight: "bold",
            fontSize: 12,
            marginBottom: 8,
        },
        heading: {
            marginTop: 8,
            lineHeight: '1.13',
            letterSpacing: '-0.5px',
            fontSize: 32,
            fontWeight: "bold",
            marginRight: 24,
        },
        details: {
            marginTop: 16,
            marginRight: 48,
            fontSize: 16,
            lineHeight: '1.5',
            letterSpacing: "normal",
            fontWeight: "normal",
        }
    });

    const intro = introStyle();
    const [position, setPosition] = useState<number>(0);
    const context = useContext(AppContext);
    let currentWeekNo = Number(context.currentWeekNo);
    const introContent = context.appContent?.[currentWeekNo];
    const steps = introContent.tasks[0].steps;
    let introTranscriptStep = steps[position]
    let history = useHistory();

    async function advanceTask(taskId: string){
        const appService = new AppService();
        const newTasks = await appService.advanceTask(BASE_URL + `recovery2/advance-task/`, taskId);
        console.log(newTasks)
    }

    async function moveNextContent() {
        let currentPosition = position;
        if (position >= (steps.length - 1)) {
            await advanceTask(introContent.tasks[0].id);
            context.setCurrentWeekNo(1);
            history.push(`/home/${context.deviceId}/${context.recoveryId}`);
        } else {
            currentPosition++;
            setPosition(currentPosition);
        }
    }



    if(Number(context.currentWeekNo) > 0) {
        return <Redirect to={`/home/${context.recoveryId}`}/>
    }
    return (
        <div className={'intro'}>
            <div className={'intro-container'}>
                <img src={AppIcon} alt={"AppIcon"}/>
                {(position === 0) ? (
                    <>
                        <div className={'greet'}>WELCOME TO ASCEND</div>
                        <p className={'heading'}>Your journey begins here.</p>
                    </>
                    ) : ( <div className={'greet'}></div>)}

                <p className={'details'}>{(introTranscriptStep.data.transcript)}</p>
                <div className={'intro-action-area'}>
                    <ActionButton theme={ButtonTheme.LIGHT}
                                  primaryOnClicked={moveNextContent}
                                  primaryText={(introTranscriptStep.data.next_button_label) ? introTranscriptStep.data.next_button_label: "Next" }
                                  secondaryText={''} />
                </div>
            </div>


        </div>
    );
}

export default Intro;